import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import { UseQueryConfig } from '@/api/types';
import { opobffOrganizationQueryKeys } from './opobff-organization.keys';

export const opobffOrganizationQueries = {
  item: () =>
    queryOptions({
      queryKey: opobffOrganizationQueryKeys.getItem(),
      queryFn: () => api.opobffOrganization.getOrganization(),
    }),
};

export const useOpobffOrganizationQuery = (options?: UseQueryConfig) => {
  return useQuery({ ...opobffOrganizationQueries.item(), ...options });
};
